export interface FundPerformanceAnnualizedState {
  perfAsOfDate: string;
  sinceInceptionReturnDate: string;
  lumpsumData: FundPerformanceLumpsumData;
  sipData: FundPerformanceTableData[];
  isLoaded?: boolean;
  showDiscretePerformance?: boolean;
}

export interface FundPerformanceLumpsumData {
  annualized: FundPerformanceTableContent;
  cumulative: FundPerformanceTableContent;
  discrete?: FundPerformanceTableContent;
  annualizedCurrent?: FundPerformanceTableContent;
}

export interface FundPerformanceTableContent {
  performance: FundPerformanceTableData;
  bmPerformance: FundPerformanceTableData[];
}

export interface FundPerformanceTableData {
  bmLabel?: string;
  bmName?: string;
  year1Return?: string;
  year2Return?: string;
  year3Return?: string;
  year4Return?: string;
  year5Return?: string;
  year10Return?: string;
  year15Return?: string;
  year1CurrentReturn?: string;
  year2CurrentReturn?: string;
  year3CurrentReturn?: string;
  year4CurrentReturn?: string;
  year5CurrentReturn?: string;
  year10CurrentReturn?: string;
  year15CurrentReturn?: string;
  sinceInceptionReturn?: string;
  sinceInceptionCurrentReturn?: string;
}

export enum FundPerformanceSIPRowName {
  'PERF_TOTAL_INVESTED',
  'PERF_TOTAL_VALUE',
  'PERF_RETURNS',
  'SIP_NET',
  'BM_PERF_TOTAL_VALUE_INSTA_1',
  'BM_PERF_TOTAL_VALUE_INSTA_2',
  'BM_PERF_RETURNS_INSTA_1',
  'BM_PERF_RETURNS_INSTA_2',
}

export interface FundPerformanceCummulativeState {
  inceptionDate: string;
  sinceInceptionReturnDate: string;
  isLoaded?: boolean;
  basecurrcode?: string;
}
